export const chargeMethodList = [
    {
        label: "Outlet",
        value: "Outlet"
    },
    {
        label: "Outlet Transaction",
        value: "OutletTransaction"
    },
    {
        label: "Outlet POS",
        value: "OutletPos"
    },
    {
        label: "System",
        value: "System"
    },
    {
        label: "License",
        value: "License"
    },
    {
        label: "Outlet Yearly",
        value: "OutletYearly"
    },
    {
        label: "Outlet Live Order",
        value: "OutletLiveOrder",
    },
    {
        label: "Loyalty Lite",
        value: "LoyaltyLite",
    },
    {
        label: "API Usage",
        value: "ApiUsage",
    },
];

export const subsidiaryList = [
    {
        label: "XILNEX HOLDINGS SDN BHD",
        value: "XILNEX HOLDINGS SDN BHD"
    },
    {
        label: "XILNEX (CAMBODIA) CO., LTD",
        value: "XILNEX (CAMBODIA) CO., LTD"
    }
];